import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CardActions,
  SvgIcon,
  Container,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import EastIcon from "@mui/icons-material/East";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ServicesCard({ el }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [element, setElement] = useState([]);
  useEffect(() => {
    setElement(el);
  }, []);
  return (
    <Container id="services">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "20px",
          flexWrap: "wrap",
          marginTop: "5%",
          marginBottom: "7%",
        }}
      >
        {element.map((element, index) => (
          <Card
            key={index}
            sx={{
              width: "260px",
              height: "350px",
              borderRadius: "20px",
              position: "relative",
              backgroundImage: `linear-gradient(to top, #7ABAF3, #8FBADFA3)`,
              margin: "auto",
            }}
          >
            <CardContent>
              <Typography
                gutterBottom
                sx={{
                  color: "#199CFB",
                  fontSize: "30px",
                  marginBottom: "30px",
                }}
              >
                {t(element.title)}
              </Typography>
              <Typography
                color="#1D2877"
                sx={{ fontWeight: "bold", fontSize: "20px" }}
              >
                {t(element.s1)}
                <br />
                {t(element.s2)}
                <br />
                {t(element.s3)}
                <br />
                {t(element.s4)}
                <br />
                {t(element.s5)}
                <br />
                {t(element.s6)}
                <br />
                {t(element.s7)}

                <br />
              </Typography>
            </CardContent>
            <CardActions
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/" + `${element.n}`);
              }}
            >
              <EastIcon
                sx={{
                  right: "10px",
                  cursor: "pointer",
                  color: "#1C98FB",
                  position: "absolute",
                  bottom: "5px",
                  "&:hover": { color: "white" },
                  transition: "0.5s ease",
                }}
              />
            </CardActions>
          </Card>
        ))}
      </Box>
    </Container>
  );
}
